import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Currency } from '../models/currency';
import { ContractCurrency, CurrencyOverviewRow } from '../models/contract-currency';

@Injectable({
    providedIn: 'root'
})
export class CurrencyApiService {
    private apiBaseUrl = `${environment.apiUrl}currencies`;
    private contractApiBaseUrl = `${environment.apiUrl}contract`;

    constructor(private httpClient: HttpClient) {}

    /** GET /api/currencies — list of available currencies with current exchange rates. */
    public getCurrencies(): Observable<Currency[]> {
        return this.httpClient.get<Currency[]>(this.apiBaseUrl);
    }

    /** GET /api/contract/{contractId}/currencies — all ContractCurrency rows for a contract
     *  (the contract's own record plus records for all its extensions). */
    public getContractCurrencies(contractId: number): Observable<ContractCurrency[]> {
        return this.httpClient.get<ContractCurrency[]>(
            `${this.contractApiBaseUrl}/${contractId}/currencies`
        );
    }

    /** GET /api/currencies/overview — currency overview rows for BC entry (admin only). */
    public getCurrencyOverview(): Observable<CurrencyOverviewRow[]> {
        return this.httpClient.get<CurrencyOverviewRow[]>(`${this.apiBaseUrl}/overview`);
    }

    /** PUT /api/currencies/{id}/bc — toggle the InsertedInBC flag. */
    public setInsertedInBc(id: number, insertedInBc: boolean): Observable<void> {
        return this.httpClient.put<void>(`${this.apiBaseUrl}/${id}/bc`, { insertedInBc });
    }
}
